import { api } from "../../axios";
export const state = {
  campuses: [],
};
export const mutations = {
  SET_CAMPUS(state, payload) {
    state.campuses = payload;
  },
  SET_DELIVERY_UNITS_PER_CAMPUS(state, { campusId, deliveryUnits }) {
    const campus = state.campuses.find((c) => c.id === campusId);
    campus.deliveryUnits = deliveryUnits;
  },
};
export const actions = {
  // Campus
  GetCampus() {
    return api.get("Campus/GetAllCampuss");
  },
  GetPublicCampus() {
    return api.get("Campus/All/Public");
  },
  GetCampusByAgency(context, data) {
    return api.get(`Campus/Agency/${data}`);
  },
  GetSingleCampus(context, data) {
    return api.get(`Campus/${data}`);
  },
  UpdateCampus(context, data) {
    return api.put(`Campus/${data.id}`, data);
  },
  DeleteCampus(context, data) {
    return api.delete(`Campus/${data}`);
  },
  CreateCampus(context, data) {
    return api.post(`Campus/CreateCampus`, data);
  },
};
